import { storage } from 'BASE/common/util/util.storage';
import * as apiProxy from 'BASE/common/util/util.apiProxy';
import { datadogRum } from '@datadog/browser-rum';

const install = async function (Vue, { isMobile, router }) {
    // production 才啟用
    if (!ENVIRONMENT.PRODUCTION) {
        return;
    }
    
    let defaultParameter = {
        site: 'us3.datadoghq.com',
        service: ENVIRONMENT.CORDOVA ? 'clientapp-ionic' : 'clientapp-h5',
        version: '2025.09.02.406', // 由部署時替換
    };

    try {
        let parameters;
        let config = await $.getJSON(apiProxy.urlCombine('/api/Datadog/Get'));
        if (config.DatadogRumPcEnable || config.DatadogRumMobileEnable) {
            try {
                parameters = JSON.parse(config.DatadogRumConfig);
                Object.assign(parameters, defaultParameter);
            } catch {
                // 解析錯誤
                console.warn('DatadogRumConfig parse fail');
            }
        }

        let ignorePaths = ['/api/Wallet/GetWalletAmount', '/api/Bet/IssueInfo/'];

        if (
            parameters !== undefined &&
            ((config.DatadogRumPcEnable && !isMobile) || (config.DatadogRumMobileEnable && isMobile))
        ) {
            // 送出追蹤前處理
            parameters.beforeSend = (event, context) => {
                if (
                    event.type === 'resource' &&
                    event.resource.type === 'xhr' &&
                    ignorePaths.find(
                        (ignorePath) => event.resource.url.toLowerCase().indexOf(ignorePath.toLowerCase()) != -1
                    )
                ) {
                    return false;
                }
                else if (event.type === 'resource' && event.resource.url.includes('localhost')) {
                    return false;
                }
                else if (event.type === 'resource' && event.resource.transfer_size === 0) {
                    return false;
                }

                if (storage.local.get(storage.keys.USER_NAME) !== null) {
                    datadogRum.setUser({ name: storage.local.get(storage.keys.USER_NAME) });
                }
            };

            // 要自定義View名稱
            if (ENVIRONMENT.CORDOVA) {
                parameters.trackViewsManually = true;
            }

            datadogRum.init(parameters);

            datadogRum.setGlobalContextProperty('ionic', ENVIRONMENT.CORDOVA);
            datadogRum.setGlobalContextProperty('mobile', isMobile);
            const isPWA = storage.local.get(storage.keys.ISPWA);

            // App資訊
            if (ENVIRONMENT.CORDOVA) {
                datadogRum.setGlobalContextProperty('deviceUUID', window.localStorage.DEVICE_UUID);
                datadogRum.setGlobalContextProperty('bundleVersion', window.localStorage.BUNDLE_VERSION);
                datadogRum.setGlobalContextProperty('appVersion', window.localStorage.APP_VERSION);
                datadogRum.setGlobalContextProperty('pwa', isPWA ? true : false);

                // APP View name要自行設定
                if (router !== undefined) {
                    router.beforeEach((to, from, next) => {
                        datadogRum.startView({ name: to.path !== undefined ? to.path : '' });
                        next();
                    });
                }
            }

            if (parameters.sessionReplaySampleRate !== undefined && parameters.sessionReplaySampleRate > 0) {
                datadogRum.startSessionReplayRecording();
            }
        }

        Vue.datadogRum = datadogRum;

        Object.defineProperty(Vue.prototype, '$datadogRum', {
            get: () => Vue.datadogRum,
        });
    } catch (e) {
        return;
    }
};

export default install;
